// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Wifi = React.forwardRef(function Wifi(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Wifi" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M3 9.51262L4.63636 11.0558C8.70273 7.22103 15.2973 7.22103 19.3636 11.0558L21 9.51262C16.0336 4.82913 7.97455 4.82913 3 9.51262ZM9.54545 15.6853L12 18L14.4545 15.6853C13.1045 14.4044 10.9036 14.4044 9.54545 15.6853ZM6.27273 12.5989L7.90909 14.1421C10.1673 12.0125 13.8327 12.0125 16.0909 14.1421L17.7273 12.5989C14.5691 9.62064 9.43909 9.62064 6.27273 12.5989Z", fill: "currentColor" }))));
});
Wifi.displayName = 'Wifi';
export default Wifi;
//# sourceMappingURL=Wifi.js.map